import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { NbSidebarService } from '@nebular/theme';
import { Observable, Subscription } from 'rxjs';
import { LayoutService } from '../layout.service';
import { ActionState, ComponentConfig, ComponentState, Relation } from '../shared/model';
import { UbsComponentStoreService } from '../ubs-component-store.service';
import { ViewContainersService } from '../shared/services/view-containers.service';
import { OfbizForm, RemoteFormData } from '@urbannex/ofbiz-forms';
import { BreadCrumbData,SelectedValue } from '../shared/model';

@Component({
  selector: 'ubs-header-container',
  templateUrl: './header-container.component.html',
  styleUrls: ['./header-container.component.scss']
})
export class HeaderContainerComponent implements OnInit {
  //@Input() componentConfig:ComponentConfig;
  //@Input() selectedValue:SelectedValue;
  @Input()
  //get state():Observable<ComponentState> {return this.state}
  set state(state:Observable<ComponentState>){
    state.subscribe(componentState => {
      console.log("BreadCrumbs in headerContainer",componentState.breadCrumbs)
      this.componentConfig = componentState.componentConfig;
      this.selectedValue = componentState.selectedValue;
      this.breadCrumbs = componentState.breadCrumbs;
      if(this.componentConfig != undefined){
        if(this.componentConfig.relations != null && this.componentConfig.relations && undefined){
          this.relations = this.componentConfig.relations;
        }
      }
      
    })
  }
  componentConfig:ComponentConfig;
  selectedValue:SelectedValue
  //state$ = this.componentStore.vm$;
  breadCrumbs:BreadCrumbData[];
  hasSelectedValue = false;
  searchExpanded:boolean = false;
  breadCrumbAlert:Subscription;
  activeBreadCrumb:BreadCrumbData;
  level:number;
  relations:Relation[];

  @Output() setTopList = new EventEmitter();

  constructor(private componentStore:UbsComponentStoreService,
    private viewContainersService:ViewContainersService,
    private sidebarService: NbSidebarService,
    private layoutService: LayoutService) { 
      this.breadCrumbAlert = this.viewContainersService.getNotifiedSuccess()
      .subscribe((remoteFormData:RemoteFormData) => {
        if(remoteFormData != null){
          //console.log("RemoteData coming in from alert",remoteFormData);
          console.log({breadCrumbs:this.breadCrumbs});
          this.breadCrumbFromRemoteFormData(remoteFormData);
        }
      });
      this.componentStore.selectedValue$
        .subscribe((selectedValue:SelectedValue) => {
          if(selectedValue){
            console.log({TrackSelectedValue:"HeaderContainerComponent",value:selectedValue,componentConfig:this.componentConfig,level:this.level});
            this.selectedValue = selectedValue;
            if(this.selectedValue.event === "edit"){
              //console.log({TrackEditString:this.activeBreadCrumb.editFormText});
              if(!this.activeBreadCrumb.editFormText.includes(this.selectedValue.label)){
                if(this.activeBreadCrumb.editFormText.includes(" | ")){
                  let prefix = this.activeBreadCrumb.editFormText.substring(0,this.activeBreadCrumb.editFormText.indexOf(" | "));
                  this.activeBreadCrumb.editFormText = prefix+" | "+this.selectedValue.label;
                }else{
                  this.activeBreadCrumb.editFormText = this.activeBreadCrumb.editFormText+" | "+this.selectedValue.label;
                }
              }
              

              if(this.componentConfig.relations != undefined && this.componentConfig.relations.length > 0){
                this.relations = this.componentConfig.relations;
                console.log({TrackComponentConfig:"HeaderContainerComponent",value:this.componentConfig});
              }else if(this.level == 2 && this.componentConfig.childComponent.relations != undefined && this.componentConfig.childComponent.relations.length > 0){
                this.relations = this.componentConfig.childComponent.relations;
              }
            }
          }
        });
        this.sidebarService.onCollapse().subscribe(data => console.log(data));
    }

  ngOnInit(): void {
    console.log({breadCrumbs:this.breadCrumbs});
    console.log({activeBreadCrumb:this.activeBreadCrumb});
    if(this.activeBreadCrumb == undefined && this.breadCrumbs != undefined){
      this.activeBreadCrumb = this.breadCrumbs[0];
    }
    this.sidebarService.collapse('settings-sidebar');
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["state"]){
      console.log({TrackSelectedValue:"HeaderContainerComponent",value:this.selectedValue});
    }
  }

  breadCrumbFromRemoteFormData(remoteFormData:RemoteFormData){
    console.log({"SettingBreadCrumbFromRemoteFormData":remoteFormData})
    if(this.breadCrumbs != undefined){
      let breadCrumb:BreadCrumbData = this.breadCrumbs.find((element:BreadCrumbData) => {
        if(element.selectedValue !== undefined){
          return element.selectedValue.data.formData.formName == remoteFormData.formData.formName
        }
          //element?.selectedValue.data.formData.formName == remoteFormData.formData.formName
      });
      if(breadCrumb){
        if(this.selectedValue){
          //Update breadCrumb with values from the selectedValue
          if(this.selectedValue.label){
            breadCrumb.label = this.selectedValue.label;
          }
          if(this.selectedValue.data){
            breadCrumb.selectedValue.data = this.selectedValue.data;
          }
        }
        this.activeBreadCrumb = breadCrumb;
        this.level = this.activeBreadCrumb.level;
        //console.log({activeBreadCrumbAndLevel:{activeBreadCrumb:this.activeBreadCrumb,level:this.level,selectedValue:this.selectedValue}});
      }
    }
  }

  selectBreadCrumb(breadCrumb:BreadCrumbData){
    console.log("selectedBreadCrumb in HeaderContainerComponent",breadCrumb);
    this.viewContainersService.setListSelectedValue(breadCrumb.selectedValue);
    //this.componentStore.updateSelectedValue(breadCrumb.selectedValue);
    this.componentStore.updateAction(ActionState.LIST);
  }
  
  toggleRightSidebar():boolean{
    this.sidebarService.toggle(false, 'settings-sidebar');
    this.layoutService.changeLayoutSize();

    return true;
  }

  toggleBreadCrumbs(e){
    this.searchExpanded = !this.searchExpanded;
  }

  loadFind():boolean{
    /* console.log("Fokkof");
    this.componentConfig.searchResults = null;
    this.componentStore.updateComponentConfig(this.componentConfig); */
    this.componentStore.updateAction(ActionState.FIND);
    return true;
  }

  loadCreateView(level:number){
    //let createForms:OfbizForm[] = [];
    //createForms.push(this.componentConfig.addForm);
    console.log("the level HeaderContainerComponent",level);
    this.viewContainersService.setActiveLevel(level);
    //this.componentStore.updateActiveLevel(level);
    this.loadCreate();
  }

  loadCreate():void{
    //console.log("loadCreate clicked");
    //this.componentStore.updateSelectedValue(null);
    this.hasSelectedValue = false;
    //this.componentStore.updateAction(ActionState.ADD);
    //return true;
  }
  loadList():void{
    console.log("Loading list .....");
    this.componentStore.updateSelectedValue(null);
    this.viewContainersService.setHasSearchResults(false);
    this.componentStore.updateAction(ActionState.LIST);
    //console.log("selectedValue")
    //this.componentStore.action$.pipe().subscribe(data => console.log("action",data));
    //this.componentStore.selectedValue$.pipe().subscribe(data => console.log("selectedValue",data));
    /* this.componentStore.action$.pipe().subscribe(data => {
      if(data == "list"){
        this.setTopList.emit();
      }else{
        this.componentStore.updateSelectedValue(null);
        this.viewContainersService.setHasSearchResults(false);
        this.componentStore.updateAction(ActionState.LIST);
      }
    }); */
    
  }

  loadView():void{
    this.componentStore.updateAction(ActionState.VIEW);
  }

  editSelected(e):void{
    console.log({TrackEditSelected:e});
    this.componentStore.updateAction(ActionState.EDIT);
  }

  loadEdit(){
    this.componentStore.selectedValue$
    .subscribe(data => {
      if(data){
        this.componentStore.updateAction(ActionState.EDIT);
      }      
    })
  }

  getSearchResults(data){
    console.log({"searcgResults":data});
    this.componentConfig.searchResults = data;
    this.componentStore.updateComponentConfig(this.componentConfig);
    this.viewContainersService.setHasSearchResults(true);
  }

  getSelectedValue(data){
    console.log({"selectedValue":data});
    this.componentStore.updateSelectedValue(data);
    this.componentStore.updateAction(ActionState.EDIT);
  }



}
